import enDict from './en-dict';

export function checker(value) {
  if (value) {
    return enDict.includes(value.toLowerCase());
  }
  return false;
}
